import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const RequirementsColumnSelectDescription = () =>
  <Paragraph>
    <strong>
      <Color variant='theme-description-text'>
        Select the Requirement ID and Requirement Description columns to import into DAI. Please make sure the selected columns are not empty and contain valid data.
      </Color>
    </strong>
  </Paragraph>

export default RequirementsColumnSelectDescription
